import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { db } from '../firebase';
import { doc, updateDoc } from 'firebase/firestore';

const NilUSuccess = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const sessionId = searchParams.get('session_id');
  const orderId = searchParams.get('order_id');

  useEffect(() => {
    const confirmOrder = async () => {
      try {
        if (orderId) {
          await updateDoc(doc(db, 'nil-u-orders', orderId), {
            status: 'paid',
            stripeSessionId: sessionId || null,
            paidAt: new Date(),
          });
        }
        setStatus('success');
      } catch {
        setStatus('success');
      }
    };
    confirmOrder();
  }, [orderId, sessionId]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <svg className="animate-spin w-10 h-10 text-spi-600 mx-auto mb-4" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
          <p className="text-gray-500">Confirming your order...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <section className="py-24 sm:py-32">
        <div className="max-w-2xl mx-auto px-6 lg:px-8 text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-8">
            <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h1 className="text-3xl sm:text-4xl font-light text-gray-900 mb-4">
            Payment Successful
          </h1>
          <p className="text-gray-500 text-lg mb-8 leading-relaxed">
            Thank you for your NIL U purchase. We've received your order and will be creating accounts for your students shortly.
          </p>

          {/* What Happens Next */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 text-left mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-6">What happens next?</h2>
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-spi-100 text-spi-700 flex items-center justify-center text-sm font-semibold">
                  1
                </div>
                <div>
                  <p className="text-gray-900 font-medium">Order confirmation</p>
                  <p className="text-gray-500 text-sm">You'll receive a payment receipt at the email address you provided.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-spi-100 text-spi-700 flex items-center justify-center text-sm font-semibold">
                  2
                </div>
                <div>
                  <p className="text-gray-900 font-medium">Account creation</p>
                  <p className="text-gray-500 text-sm">Our team will create individual student accounts using the email addresses you provided.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-spi-100 text-spi-700 flex items-center justify-center text-sm font-semibold">
                  3
                </div>
                <div>
                  <p className="text-gray-900 font-medium">Student access</p>
                  <p className="text-gray-500 text-sm">Each student will receive their login credentials via email to access the NIL U course.</p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-gray-400 text-sm mb-8">
            Questions? Contact us at{' '}
            <a href="mailto:sonom.advantage@gmail.com" className="text-spi-600 hover:text-spi-700">
              sonom.advantage@gmail.com
            </a>
          </p>

          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-gray-900 text-white hover:bg-gray-800 transition-colors rounded-lg font-medium"
          >
            Back to Home
          </Link>
        </div>
      </section>
    </div>
  );
};

export default NilUSuccess;
